module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 299.21 110.93\"><path d=\"M99.8 15.52V2H80.91v12.68h-62V2H0v13.52A49.86 49.86 0 0 0 20.71 56a50.47 50.47 0 0 0-6.09 5.19A49.58 49.58 0 0 0 0 96.43V110h18.9V97.27h62V110h18.9V96.43A49.86 49.86 0 0 0 79.1 56a50.58 50.58 0 0 0 6.1-5.19 49.58 49.58 0 0 0 14.6-35.29zM75.08 78.37H24.7a31.39 31.39 0 0 1 3.3-3.86 31 31 0 0 1 47.1 3.86zM24.72 33.58H75.1a31.41 31.41 0 0 1-3.28 3.86 30.8 30.8 0 0 1-21.92 9.09 31 31 0 0 1-25.18-12.95z\" class=\"cls-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-science.svg
// module id = 291
// module chunks = 1